import { Box } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";

const CIRCLE_SIZE = 32;
const LINE_WIDTH = 3;
const GAP_SIZE = 10;

type Props = {
  stepSpacing: number;
};

export const TimelineConnector = ({ stepSpacing }: Props) => (
  <Box
    position="absolute"
    top={CIRCLE_SIZE + GAP_SIZE}
    left={`calc(${CIRCLE_SIZE / 2}px - ${LINE_WIDTH / 2}px)`}
    width={LINE_WIDTH}
    zIndex={0}
    sx={{ backgroundColor: Colors.MediumGrey }}
    height={({ spacing }) =>
      `calc(100% + ${spacing(stepSpacing)} - ${CIRCLE_SIZE + GAP_SIZE * 2}px)`
    }
  />
);
